import React, { useState } from "react";
import FilterIcon from "../../../../assets/icons/filter.svg";

const categories = [
  "All", "Tech", "Art", "Music", "Science", "Content",
  "Fashion", "Gaming", "Food", "Craft"
];

const SELECTED_COLOR = "#787486";

const CATEGORY_COLORS = {
  Tech: "#4D8EFF",
  Art: "#68B266",
  Music: "#A162E8",
  Science: "#45B9B0",
  Content: "#D58D49",
  Fashion: "#FF8BA7",
  Gaming: "#FF7070",
  Food: "#FFA500",
  Craft: "#A084E8",
};

const FilterSection = ({ selectedCategory = "All", onSelectCategory }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const currentColor =
    selectedCategory === "All"
      ? SELECTED_COLOR
      : CATEGORY_COLORS[selectedCategory] || SELECTED_COLOR;

  return (
    <div className="relative w-36 h-10 rounded-md border border-zinc-500 flex items-center justify-center z-10">
      <button
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className="w-full h-full px-3 text-sm font-normal text-zinc-500 font-['Inter'] text-center flex items-center justify-center gap-2"
      >
        <img src={FilterIcon} alt="Filter" className="w-4 h-4" />
        {selectedCategory === "All" ? "Filter ▾" : `${selectedCategory} ▾`}
      </button>

      {dropdownOpen && (
        <div className="absolute left-0 top-full mt-1 w-44 rounded-lg border border-gray-200 bg-white shadow-lg z-20">
          {categories.map((cat) => {
            const color =
              cat === "All" ? SELECTED_COLOR : CATEGORY_COLORS[cat] || SELECTED_COLOR;

            return (
              <div
                key={cat}
                onClick={() => {
                  onSelectCategory(cat);
                  setDropdownOpen(false);
                }}
                className="px-4 py-2 text-sm cursor-pointer whitespace-nowrap hover:bg-gray-100 transition"
                style={{
                  color,
                  fontWeight: selectedCategory === cat ? "600" : "normal",
                  backgroundColor:
                    selectedCategory === cat ? `${color}15` : "#fff",
                }}
              >
                {cat}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FilterSection;
